module.exports = __webpack_public_path__ + "media/images/front/icons/check-square-65967509657a961dfa86ff4596d05786.svg";